import { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';

import { Button, MenuItem, OverflowMenu, spacing } from '@pletly/ui';
import ExpandIcon from '%assets/icons/chevron-down.svg';
import { CONNECTIONS_MANAGE_ENABLED } from '%constants/connections';
import { useCreateAccount } from '%services/payment/useCreateAccount';
import { useToggle } from '%hooks';

export const AddConnectionMenu = () => {
	const { t } = useTranslation();
	const { navigate } = useNavigation();
	const { goToCreateAccount } = useCreateAccount();
	const [isMenuOpened, toggleMenu] = useToggle();

	const goToCreate = useCallback(() => {
		toggleMenu();

		return goToCreateAccount();
	}, [goToCreateAccount, toggleMenu]);

	const goToConnect = useCallback(() => {
		toggleMenu();

		return navigate('ConnectUser');
	}, [navigate, toggleMenu]);

	const renderAnchor = useCallback(
		() => (
			<Button
				variant="outline"
				size="small"
				accessoryRight={<ExpandIcon />}
				color="primary"
				onPress={toggleMenu}
			>
				{t('connections.add-connection')}
			</Button>
		),
		[t, toggleMenu],
	);

	if (!CONNECTIONS_MANAGE_ENABLED) {
		return null;
	}

	return (
		<OverflowMenu
			anchor={renderAnchor}
			visible={isMenuOpened}
			onBackdropPress={toggleMenu}
			placement="bottom end"
			style={styles.menu}
		>
			<MenuItem title={t('connections.create-care-receiver')} onPress={goToCreate} />
			<MenuItem title={t('connections.connect-to-care-receiver')} onPress={goToConnect} />
		</OverflowMenu>
	);
};

const styles = StyleSheet.create({
	menu: {
		width: 'auto',
		marginTop: spacing(),
	},
});
